<form [formGroup]="form" class="time-range-report-parameter-component">
  <div class="time-range">
    <mat-label> Time Range </mat-label>
    <div class="inputs-container">
      <mat-form-field>
        <mat-label>Start Time</mat-label>
        <input required matInput type="time" formControlName="startTime" />
      </mat-form-field>
      <p class="time-range-to-break">to</p>
      <mat-form-field>
        <mat-label>End Time</mat-label>
        <input required matInput type="time" formControlName="endTime" />
      </mat-form-field>
    </div>
    @if (form.hasError('startBeforeEndError')) {
      <mat-error>Start time must be an hour before end time</mat-error>
    }
  </div>
</form>
